<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Autorização de Suporte</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid"> 
                    <div class="p-field p-col-12 p-md-2">
                        <label>Período</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                            :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>
                    </div>  
                    <div class="p-field p-col-0">
                        <Button label="Atualizar" icon="pi pi-refresh" style="margin-top: 26px;" @click="listar"/>         
                    </div>              
                </div>
                <DataTable :value="autorizações" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">	
                                <div>
                                     <Button label="Novo" icon="pi pi-plus" @click="exibirDialogConfirmarNovo=true"/>
                                </div>			
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>                    
					<Column field="autorizaPor" header="Autorizado Por" sortable></Column>
					<Column field="email" header="E-mail" sortable></Column>
                    <Column field="dataCadastro" header="Data Cadastro" sortable>
                        <template #body="slotProps">
                            {{ formatarData(slotProps.data.dataCadastro) }}
                        </template>
                    </Column>
                    <Column field="dataFinal" header="Data Final" sortable>
                        <template #body="slotProps">
                            {{ formatarData(slotProps.data.dataFinal) }}
                        </template>
                    </Column>
					<Column field="fechado" header="Fechado" sortable>
                        <template #body="slotProps">
                            <label v-if="slotProps.data.fechado">Sim</label>
                            <label v-else>Não</label>
                        </template>
                    </Column>
                    <Column>
						<template #body="slotProps">
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger p-mr-2"
                             @click="confirmarExcluir(slotProps.data)" v-if="!slotProps.data.fechado"/>							
						</template>
					</Column>                    
				</DataTable>
            </div>
        </div>

        <Dialog :visible.sync="exibirDialogConfirmarNovo" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogConfirmarNovo=false">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem;" />
				<span>Criar Autorização de Suporte?</span><br/><br/>
				<label><b>Data Final</b>: {{ getData() }}</label><br/>				
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarNovo=false"/>
				<Button label="Sim" icon="pi pi-check" @click="salvar" />
			</template>
		</Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="exibirDialogConfirmarExcluir=false">
			<div class="confirmation-content" v-if="autorizacaoExcluir">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span>Excluir Autorização?</span><br/><br/>
				<label><b>Data Cadastro</b>: {{ formatarData(autorizacaoExcluir.dataCadastro) }}</label><br/>
                <label><b>Data Final</b>: {{ formatarData(autorizacaoExcluir.dataFinal) }}</label><br/>				
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarExcluir=false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
			</template>
		</Dialog>

    </div>
</template>

<script>
import AutorizacaoSuporteService from '@/service/AutorizacaoSuporteService';
import { exibirMensagem, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    autorizacaoSuporteService: null,
    data() {
        return {
            exibirDialogConfirmarExcluir: false,
            exibirDialogConfirmarNovo: false,
            dataInicio: new Date(),
            mesAno: new Date(),
            rangeData: '',
            autorizações: [],
            autorizacaoExcluir: null,
            filtro: {},
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         */
        salvar() {
            let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.autorizacaoSuporteService.salvar(requisicao)
			.then(resp => {	
				exibirMensagem(this, resp);	
                this.exibirDialogConfirmarNovo = false;			
				this.listar();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
        }, 
        /**
         * 
         */
        excluir() {
            let aut = {
                id: this.autorizacaoExcluir.id,
            }
            let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()},
                autorizacaoSuporte: aut
			}
			this.autorizacaoSuporteService.excluir(requisicao)
			.then(resp => {	
				exibirMensagem(this, resp);	
                this.exibirDialogConfirmarExcluir = false;			
				this.listar();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },      
        /**
         * 
         */
        listar() {      
            let mes = this.mesAno.getMonth()+1;
            let ano = this.mesAno.getFullYear();      
            let idEmpresa = this.getDadosRequisicao().empresa.id;
			this.autorizacaoSuporteService.listar(idEmpresa, ano, mes)
			.then(resp => {	               
				this.autorizações = resp.data;							
			})
			.catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         * @param {*} data 
         */
        confirmarExcluir(data) {
            this.autorizacaoExcluir = data;
            this.exibirDialogConfirmarExcluir = true;
        },
        /**
         * 
         */
        getData() {
            return new Date((new Date().getTime() + (86400000 * 6))).toLocaleDateString();
        }, 
        /**
         * 
         */
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
        /**
         * 
         * @param {*} strData 
         */
        formatarData(strData) {
           if(strData) {
            let strDataHora = strData.split(' ');
            let partesData = strDataHora[0].split('-');           
            let dataFormat = partesData[2] + '/' + partesData[1] + '/' + partesData[0];          
            if(strDataHora.length > 1) {
                dataFormat  += ' ' + strDataHora[1];
            }
            return dataFormat;
           } else {
               return '';
           }
        }    
    },
    created() {
        this.autorizacaoSuporteService = new AutorizacaoSuporteService();
    },
    mounted() {        
        this.criarRangeData();
        this.listar();
    }
}
</script>

<style>

</style>